import { styled, lighten, darken } from '@mui/material/styles'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'

// Boxes with different styles
export const DefaultBox = styled(Box)(({ theme }) => ({
  color: darken(theme.palette.info.main, 0.6),
  backgroundColor: lighten(theme.palette.info.main, 0.9),
  borderRadius: 4,
  borderLeft: `2px solid ${theme.palette.info.main}`,
}))

export const SuccessBox = styled(Box)(({ theme }) => ({
  color: darken(theme.palette.success.main, 0.6),
  backgroundColor: lighten(theme.palette.success.main, 0.9),
  borderRadius: 4,
  borderLeft: `2px solid ${theme.palette.success.main}`,
}))

export const ErrorBox = styled(Box)(({ theme }) => ({
  color: darken(theme.palette.error.main, 0.6),
  backgroundColor: lighten(theme.palette.error.main, 0.9),
  borderRadius: 4,
  borderLeft: `2px solid ${theme.palette.error.main}`,
}))

export const Message = styled(Box)({
  marginRight: 16,
  fontSize: 16,
})

export const SuccessIcon = styled(Box)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.success.main,
}))

export const ErrorIcon = styled(Box)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.error.main,
}))

export const CloseButton = styled(Box)({
  padding: 0,
})

export const StyledCloseIcon = styled(CloseIcon)({
  fontSize: 12,
})
